<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="white">
        <v-toolbar-title>Ingresos</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-if="verNuevo == 0"
          class="text-xs-center"
          v-model="search"
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          v-if="verNuevo == 0"
          @click="mostrarNuevo"
          color="primary"
          dark
          class="mb-2" 
          >Nuevo</v-btn
        >
        <v-dialog v-model="verArticuloNuevo" max-width="500px">
        
          <v-card>
            <v-card-title>
              <span class="headline">Nuevo Articulo</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6 sm6 md6>
                    <v-text-field v-model="Art_codigo" label="Código">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-select
                      v-model="Art_idcategoria"
                      :items="Art_categorias"
                      label="Categoría"
                      autocomplete="on"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="Art_nombre"
                      label="Nombre"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field type="number" v-model="Art_cantidad" label="Cantidad">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field
                      type="number"
                      v-model="Art_precio_compra"
                      label="Precio Compra"
                      class="no-spinners"
                      @keydown.up.prevent="handleKeyDown"
                      @keydown.down.prevent="handleKeyDown"
                      @mousewheel="handleKeyDown"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field
                      type="number"
                      v-model="Art_precio_venta"
                      label="Precio Venta"
                      class="no-spinners"
                      @keydown.up.prevent="handleKeyDown"
                      @keydown.down.prevent="handleKeyDown"
                      @mousewheel="handleKeyDown"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="Art_descripcion"
                      label="Descripción"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-show="valida">
                    <div
                      class="red--text"
                      v-for="v in validaMensajeArticuloNuevo"
                      :key="v"
                      v-text="v"
                    ></div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="ocultarArticuloNuevo"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" flat @click.native="agregarArticuloNuevo"
                >Agregar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Articulo Nuevo -->
        <v-dialog v-model="verArticulos" max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="headline">Seleccione un artículo</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-text-field
                      append-icon="search"
                      class="text-xs-center"
                      v-model="texto"
                      label="Ingrese artículo a buscar"
                      @keyup="listarArticulo()"
                    >
                    </v-text-field>
                    <template>
                      <v-data-table
                        :headers="cabeceraArticulos"
                        :items="articulos"
                        class="elevation-1"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="justify-center layout px-0">
                            <v-icon
                              small
                              class="mr-2"
                              @click="agregarDetalle(props.item)"
                            >
                              add
                            </v-icon>
                          </td>
                          <td>{{ props.item.nombre }}</td>
                          <td>{{ props.item.categoria }}</td>
                          <td>{{ props.item.descripcion }}</td>
                        <!--   <td>{{ props.item.stock }}</td> -->
                          <td>{{ props.item.precio_compra }}</td>
                          <td>{{ props.item.precio_venta }}</td>
                        </template>
                        <template slot="no-data">
                          <h3>No hay artículos para mostrar.</h3>
                        </template>
                      </v-data-table>
                    </template>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="ocultarArticulos()" color="blue darken" flat>
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="adModal" max-width="290">
          <v-card>
            <v-card-title class="headline" v-if="adAccion == 1"
              >¿Activar Item?</v-card-title
            >
            <v-card-title class="headline" v-if="adAccion == 2"
              >¿Anular Compra?</v-card-title
            >
            <v-card-text>
              Estás a punto de
              <span v-if="adAccion == 1">Activar </span>
              <span v-if="adAccion == 2">Anular </span>
              la compra con No. {{ adNombre }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat="flat"
                @click="activarDesactivarCerrar"
              >
                Cancelar
              </v-btn>
              <v-btn
                v-if="adAccion == 1"
                color="orange darken-4"
                flat="flat"
                @click="activar"
              >
                Activar
              </v-btn>
              <v-btn
                v-if="adAccion == 2"
                color="orange darken-4"
                flat="flat"
                @click="desactivar"
              >
                Anular
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="ingresos"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template slot="items" slot-scope="props">
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="verDetalles(props.item)">
              tab
            </v-icon>
            <template v-if="props.item.estado != 'Anulado'  && isToday(props.item.fecha) ">
              <v-icon small @click="activarDesactivarMostrar(2, props.item)">
                block
              </v-icon>
            </template>
          </td>
          <td>{{ props.item.usuario }}</td>
          <td>{{ props.item.sucursal }}</td>
          <td>{{ props.item.proveedor }}</td>
          <td>{{ props.item.tipo_comprobante }}</td>
          <td>{{ props.item.serie_comprobante }}</td>
          <td>{{ props.item.num_comprobante }}</td>
          <td>{{ props.item.fecha_hora | moment("DD/MM/YYYY") }}</td>
          <td>{{ props.item.impuesto | currency }}</td>
          <td>{{ props.item.total | currency }}</td>
          <td>
            <div v-if="props.item.estado == 'Aceptado' ||props.item.estado == 'CANCELADO' ">
              <span class="green--text">CANCELADO</span>
            </div>
            <div v-else>
              <span class="red--text">{{ props.item.estado }}</span>
            </div>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="listar">Resetear</v-btn>
        </template>
      </v-data-table>
      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
        <v-layout row wrap>
          <v-flex xs12 sm4 md4 lg4 xl4>
            <v-select
              v-model="tipo_comprobante"
              :items="comprobantes"
              label="Tipo Factura"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 xl4>
            <v-text-field v-model="serie_comprobante" label="Serie Comprobante">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 xl4>
            <v-text-field v-model="num_comprobante" label="Número Comprobante">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm8 md8 lg8 xl8>
            <v-select
              v-model="idproveedor"
              :items="proveedores"
              label="Proveedor"
              autocomplete="on"
            >
            </v-select>
            <v-flex xs12 sm6 md6 lg6 xl6>
            <v-select
              :readonly="cambiarBodega"
              v-model="idbodega"
              :items="bodegas"
              label="Bodega"
            >
            </v-select>
          </v-flex>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 xl4>
            <v-text-field required type="number" v-model="impuesto" label="Impuesto">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm8 md8 lg8 xl8>
            <v-text-field
              @keyup.enter="buscarCodigo()"
              v-model="codigo"
              label="Código"
            >
            </v-text-field>            
          </v-flex>
          <v-flex xs12 sm2 md2 lg2 xl2>
            <v-btn @click="mostrarArticulos()" small fab dark color="teal">
              <v-icon dark>list</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm2 md2 lg2 xl2>
            <v-btn 
                @click="mostrarArticuloNuevo" 
                color="primary" 
                dark 
                class="d-flex align-center justify-center rounded-xl pa-3" 
                style="background-color: #00bcd4 !important;" 
              >
                <v-icon left style="color: white;">add</v-icon>
                <span class="ml-3" style="color: white; font-weight: bold;">Nuevo Articulo</span>
        </v-btn>



         </v-flex>
          <v-flex xs12 sm2 md2 lg2 xl2 v-if="errorArticulo">
            <div class="red--text" v-text="errorArticulo"></div>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-data-table
              :headers="cabeceraDetalles"
              :items="detalles"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center layout px-0">
                  <v-icon
                    small
                    class="mr-2"
                    @click="eliminarDetalle(detalles, props.item)"
                  >
                    delete
                  </v-icon>
                </td>
                <td>{{ props.item.codigo }}</td>
                <td>{{ props.item.articulo }}</td>
                <td>
                  <v-text-field
                    type="number"
                    v-model="props.item.cantidad"
                    class="no-spinners"
                    @keydown.up.prevent="handleKeyDown"
                    @keydown.down.prevent="handleKeyDown"
                    @mousewheel="handleKeyDown"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    type="number"
                    v-model="props.item.precio"
                    class="no-spinners"
                    @keydown.up.prevent="handleKeyDown"
                    @keydown.down.prevent="handleKeyDown"
                    @mousewheel="handleKeyDown"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    type="number"
                    v-model="props.item.precio_venta"
                    class="no-spinners"
                    @keydown.up.prevent="handleKeyDown"
                    @keydown.down.prevent="handleKeyDown"
                    @mousewheel="handleKeyDown"
                  ></v-text-field>
                </td>
                <td>{{ props.item.cantidad * props.item.precio | currency }}</td>
              </template>
              <template slot="no-data">
                <h3>No hay artículos agregados al detalle.</h3>
              </template>
            </v-data-table>
            <v-flex class="text-xs-right">
              <strong>Subtotal: </strong>
              {{ (totalParcial = calcularTotal.toFixed(2)) | currency }}
            </v-flex>
            <v-flex class="text-xs-right">
              <strong>Total Impuesto: </strong>
              {{ (totalImpuesto = impuesto) | currency }}
            </v-flex>
            <v-flex class="text-xs-right">
              <strong>Total Neto: </strong>
              {{
                (total =
                  parseFloat(totalImpuesto) + parseFloat(totalParcial)).toFixed(
                  2
                ) | currency
              }}
            </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <div
              class="red--text"
              v-for="v in validaMensaje"
              :key="v"
              v-text="v"
            ></div>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-btn @click="ocultarNuevo()" color="blue darken-1" flat
              >Cancelar</v-btn
            >
            <v-btn v-if="verDet == 0" :disabled="ocultarboton" @click="guardar()" color="success"
              >Guardar</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<style>
.no-spinners input::-webkit-outer-spin-button,
.no-spinners input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinners input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert";
export default {
  data() {
    return {
       ocultarboton: false,
      ingresos: [],
      dialog: false,
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Usuario", value: "usuario", sortable: false },
        { text: "Sucursal", value: "sucursal", sortable: false },
        { text: "Proveedor", value: "proveedor", sortable: false },
        { text: "Tipo Factura", value: "tipo_comprobante", sortable: false },
        {
          text: "Serie Comprobante",
          value: "serie_comprobante",
          sortable: false,
        },
        {
          text: "Número Comprobante",
          value: "num_comprobante",
          sortable: false,
        },
        { text: "Fecha", value: "fecha_hora", sortable: false },
        { text: "Impuesto", value: "impuesto", sortable: false },
        { text: "Total", value: "total", sortable: false },
        { text: "Estado", value: "estado", sortable: false },
      ],
      cabeceraDetalles: [
        { text: "Borrar", value: "borrar", sortable: false },
        { text: "Codigo", value: "articulo", sortable: false },
        { text: "Artículo", value: "articulo", sortable: false },
        { text: "Cantidad", value: "cantidad", sortable: false },
        { text: "Precio Compra", value: "precio", sortable: false },
        { text: "Precio Venta", value: "precio_venta", sortable: false },
        { text: "Subtotal", value: "subtotal", sortable: false },
      ],
      // Articulo Nuevo
      Art_idcategoria: "",
      Art_categorias: [],
      Art_categorys: [],
      Art_codigo: "",
      Art_nombre: "",
      Art_cantidad: 0,
      Art_precio_venta: 0,
      Art_precio_compra: 0,
      Art_descripcion: "",
      //Fin Articulo Nuevo
      detalles: [],
      search: "",
      id: "",
      idproveedor: "",
      idbodega: "",
      proveedores: [],
      bodegas: [],
      tipo_comprobante: "",
      comprobantes: ["CONTADO", "CREDITO"],
      serie_comprobante: "",
      num_comprobante: "",
      impuesto: 0.0,
      codigo: "",
      verNuevo: 0,
      errorArticulo: null,
      totalParcial: 0,
      totalImpuesto: 0,
      total: 0,
      articulos: [],
      texto: "",
      cabeceraArticulos: [
        { text: "Seleccionar", value: "seleccionar", sortable: false },
        { text: "Artículo", value: "articulo" },
        { text: "Categoría", value: "categoria" },
        { text: "Descripción", value: "descripcion", sortable: false },
       // { text: "Stock", value: "stock", sortable: false },
        { text: "Precio Compra", value: "precio_compra", sortable: false },
        { text: "Precio Venta", value: "precio_venta", sortable: false },
      ],
      articulos: [],
      texto: "",
      verArticulos: 0,
      verArticuloNuevo: 0,
      verDet: 0,
      valida: 0,
      validaMensaje: [],
      validaMensajeArticuloNuevo: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
    };
  },
  computed: {
    calcularTotal: function () {
      var resultado = 0.0;
      for (var i = 0; i < this.detalles.length; i++) {
        resultado =
          resultado + this.detalles[i].precio * this.detalles[i].cantidad;
      }
      return resultado;
    },
  },

  watch: {
    
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.select();
    this.selectSucursal();
    this.selectCategoriaArticulo();
    this.idbodega = parseInt(this.$store.state.usuario.idsucursal);
  },
  methods: {
    handleKeyDown(event) {
     
        event.preventDefault(); // Evitar el comportamiento por defecto de la flecha hacia arriba      
    },
    selectCategoriaArticulo() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      var categoriasArray = [];
      axios
        .get("api/Categorias/Select", configuracion)
        .then(function (response) {
          categoriasArray = response.data;
          categoriasArray.map(function (x) {
            me.Art_categorias.push({ text: x.nombre, value: x.idcategoria });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onChange:function(event){
       console.log(event.target.value);
    },
    redirigir() {
      // this.$router.push({ name: "login" });
      this.$store.dispatch("salir");
    },
    mostrarNuevo() {
      this.verNuevo = 1;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    buscarCodigo() {
      let me = this;
      me.errorArticulo = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Articulos/BuscarCodigoIngreso/" + this.codigo, configuracion)
        .then(function (response) {
          //this.codigo="";
          me.codigo="";
          //console.log(response);
          me.agregarDetalle(response.data);
        })
        .catch(function (error) {
          console.log(error);
          me.errorArticulo = "No existe el artículo";
        });
    },
    listarArticulo() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Articulos/ListarIngreso/" + me.texto, configuracion)
        .then(function (response) {
          //console.log(response);
          me.articulos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectSucursal() {
      let me = this;
      var BodegasArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Articulos/Sucursal", configuracion)
        .then(function (response) {
          BodegasArray = response.data;
          console.log("Bodegas", BodegasArray);
          BodegasArray.map(function (x) {
            me.bodegas.push({ text: x.name, value: x.id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarArticulos() {
      this.verArticulos = 1;
    },
    ocultarArticulos() {
      this.verArticulos = 0;
    },
    mostrarArticuloNuevo() {
      this.verArticuloNuevo = 1;
    },
    ocultarArticuloNuevo() {
      this.verArticuloNuevo = 0;
    },
    agregarDetalle(data = []) {
      this.errorArticulo = null;
      if (this.encuentra(data["idarticulo"],data["codigo"])) {
        this.errorArticulo = "El artículo ya ha sido agregado.";
      } else {
        this.detalles.push({
          idarticulo: data["idarticulo"],
          codigo: data["codigo"],
          articulo: data["nombre"],
          cantidad: 1,
          precio: data["precio_compra"],
          precio_venta: data["precio_venta"],
        });
      }
    },
    async agregarArticuloNuevo(data = []) {
      if (this.validarArticuloNuevo()) {
        return;
      }
    const me = this;
    const headers = { Authorization: `Bearer ${this.$store.state.token}` };
    const configuracion = { headers };

    try {
        const response = await axios.get(`api/Articulos/BuscarCodigoVenta/${me.Art_codigo}`, configuracion);
        const articuloEncontrado = response.data;
      if(articuloEncontrado.success){
        swal(
                "Articulo Existente",
                "El articulo con codigo "+ articuloEncontrado.article.codigo+" ya existe",
                "warning"
            );
      }
      if(!articuloEncontrado.success){
        if (this.encuentra(null, this.Art_codigo)) {
          swal(
                "Articulo Existente",
                "El articulo con codigo "+ this.Art_codigo+" ya ha sido agregado",
                "warning"
            );
            this.errorArticulo = "El artículo ya ha sido agregado.";
            return;
        }

        // Agregar el artículo a los detalles
        this.detalles.push({
            idarticulo: 0,
            idCategoria: this.Art_idcategoria,
            codigo: this.Art_codigo,
            articulo: this.Art_nombre,
            nombreArticulo: this.Art_nombre,
            descripcionArticulo: this.Art_descripcion,
            cantidad: this.Art_cantidad,
            precio: this.Art_precio_compra,
            precio_venta: this.Art_precio_venta,
        });

        this.errorArticulo = null; 
        this.limpiarArticulo();
      }
        
    } catch (error) {
        console.error("Error al buscar el artículo:", error);

        // Manejar errores específicos
        if (error.response && error.response.status === 401) {
            swal(
                "Sesión caducada",
                "Su sesión ha expirado. Por favor, vuelva a iniciar sesión.",
                "warning"
            );
            me.redirigir(); // Redirigir al login
        } else {
            swal(
                "Error",
                "No se pudo obtener la información del artículo. Intente nuevamente.",
                "error"
            );
        }
    }
}
,
    validarArticuloNuevo() {
      this.valida = 0;
      this.validaMensajeArticuloNuevo = [];

      if (this.Art_nombre.length < 3 || this.Art_nombre.length > 50) {
        this.validaMensajeArticuloNuevo.push(
          "El nombre debe tener más de 3 caracteres y menos de 50 caracteres."
        );
      }
      if (!this.Art_idcategoria) {
        this.validaMensajeArticuloNuevo.push("Seleccione una categoría.");
      }
      /*if (!this.stock || this.stock < 0) {
        this.validaMensaje.push("Ingrese el stock inicial del artículo.");
      }*/
      if (parseFloat(this.Art_cantidad) <=0) {
        this.validaMensajeArticuloNuevo.push("El stock inicial no puede estar en 0.");
      }
      if (!this.Art_precio_venta || this.Art_precio_venta <= 0) {
        this.validaMensajeArticuloNuevo.push(
          "Ingrese un precio de venta válido para el artículo."
        );
      }
      if (!this.Art_precio_compra || this.Art_precio_compra <= 0) {
        this.validaMensajeArticuloNuevo.push(
          "Ingrese un precio de compra válido para el artículo."
        );
      }
      if (this.Art_descripcion.trim().length <= 0) {
        this.validaMensajeArticuloNuevo.push("La descripcion es un campo requerido.");
      }

      if (
        parseFloat(parseFloat(this.Art_precio_compra).toFixed(2)) >
        parseFloat(parseFloat(this.Art_precio_venta).toFixed(2))
      ) {
        this.validaMensajeArticuloNuevo.push(
          "El precio de compra no puede ser mayor que el de venta verifique los datos."
        );
      }
      if (this.validaMensajeArticuloNuevo.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    encuentra(id,codigo) {
      var sw = 0;
      for (var i = 0; i < this.detalles.length; i++) {
        if (this.detalles[i].idarticulo == id || this.detalles[i].codigo == codigo)   {
          sw = 1;
        }
      }
      return sw;
    },
    eliminarDetalle(arr, item) {
      var i = arr.indexOf(item);
      if (i !== -1) {
        arr.splice(i, 1);
      }
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Ingresos/Listar", configuracion)
        .then(function (response) {
          //console.log(response);
          me.ingresos = response.data;
        })
        .catch(function (error) {
          console.log(error);
           if (error.response.status == "401") {
            //alert("Nice");
            swal(
              "Sesión caducada",
              "Su sesión ha expirado favor volver a iniciar sesión",
              "warning"
            );
            me.redirigir();

            //router.push("login");
            // ation.href = "http://localhost8080/login";
          }
        });
    },
    listarDetalles(id) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Ingresos/ListarDetalles/" + id, configuracion)
        .then(function (response) {
          //console.log(response);
          me.detalles = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verDetalles(item) {
      this.limpiar();
      this.tipo_comprobante = item.tipo_comprobante;
      this.serie_comprobante = item.serie_comprobante;
      this.num_comprobante = item.num_comprobante;
      this.idproveedor = item.idproveedor;
      this.impuesto = item.impuesto;
      this.listarDetalles(item.idingreso);
      this.verNuevo = 1;
      this.verDet = 1;
    },
    isToday(fecha) {
    const today = new Date();
    const itemDate = new Date(fecha);

    return (
      today.getFullYear() === itemDate.getFullYear() &&
      today.getMonth() === itemDate.getMonth() &&
      today.getDate() === itemDate.getDate()
    );
  },
    select() {
      let me = this;
      var proveedoresArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Personas/SelectProveedores", configuracion)
        .then(function (response) {
          proveedoresArray = response.data;
          proveedoresArray.map(function (x) {
            me.proveedores.push({ text: x.nombre, value: x.idpersona });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      this.id = "";
      this.idproveedor = "";
      this.tipo_comprobante = "";
      this.serie_comprobante = "";
      this.num_comprobante = "";
      this.validaMensaje = [];
      this.validaMensajeArticuloNuevo = [];
      this.impuesto = 0;
      this.codigo = "";
      this.detalles = [];
      this.total = 0;
      this.totalImpuesto = 0;
      this.totalParcial = 0;
      this.verDet = 0;
    },
    limpiarArticulo() {
      this.Art_nombre = "";
      this.Art_codigo = "";
      this.Art_idcategoria = "";
      this.Art_cantidad = 0;
      this.Art_precio_compra = 0;
      this.Art_precio_venta = 0;
      this.Art_descripcion = "";
      this.ocultarArticuloNuevo();
      this.validaMensajeArticuloNuevo = [];
    
    },
    guardar() {
      if (this.validar()) {
        return;
      }
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.ocultarboton = true;
     // alert("Expira: "+me.$store.state.usuario.exp);
      axios
        .post(
          "api/Ingresos/Crear",
          {
            idproveedor: me.idproveedor,
            idusuario: me.$store.state.usuario.idusuario,
            tipo_comprobante: me.tipo_comprobante,
            serie_comprobante: me.serie_comprobante,
            num_comprobante: me.num_comprobante,
            impuesto: me.impuesto,
            total: me.total,
            idsucursal: me.idbodega,
            detalles: me.detalles,
          },
          configuracion
        )
        .then(function (response) {
          swal(
            "Compra realizada",
            "La compra se ha realizado correctamente",
            "success"
          );
            me.ocultarboton = false;
          me.ocultarNuevo();
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          swal(
            "Error al crear",
            "La compra no se ha realizado correctamente",
            "error"
          );
            me.ocultarboton = false;
          console.log(error);
        });
    },
    validar() {
      this.valida = 0;
      this.validaMensaje = [];
      let _impuesto = parseFloat(this.impuesto);
     // alert("-: "+_impuesto);
     /*   if (parseFloat(this.impuesto)<0) {
        this.validaMensaje.push("Ingrese un impuesto válido.");
      } */
      if (!this.idproveedor) {
        this.validaMensaje.push("Seleccione un proveedor.");
      }
      if (!this.tipo_comprobante) {
        this.validaMensaje.push("Seleccione un tipo de factura.");
      }
      if (!this.num_comprobante) {
        this.validaMensaje.push("Ingrese el número del factura.");
      }
     /*  if (!this.impuesto || _impuesto <0) {
        this.validaMensaje.push("Ingrese un impuesto válido.");
      } */
       
      if (this.detalles.length <= 0) {
        this.validaMensaje.push("Ingrese al menos un artículo al detalle.");
      }
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.num_comprobante;
      this.adId = item.idingreso;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    /*  activar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Usuarios/Activar/" + this.adId, {}, configuracion)
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },*/
    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Ingresos/Anular/" + this.adId, {}, configuracion)
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },

};
</script>
